import { render, staticRenderFns } from "./sidebar-shell.vue?vue&type=template&id=5be391f0&scoped=true&"
import script from "./sidebar-shell.vue?vue&type=script&lang=js&"
export * from "./sidebar-shell.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-shell.vue?vue&type=style&index=0&id=5be391f0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be391f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be391f0')) {
      api.createRecord('5be391f0', component.options)
    } else {
      api.reload('5be391f0', component.options)
    }
    module.hot.accept("./sidebar-shell.vue?vue&type=template&id=5be391f0&scoped=true&", function () {
      api.rerender('5be391f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/navegacao-v2/components/sidebar-shell.vue"
export default component.exports